import React, { useEffect, useState } from 'react';
import { Bell, RefreshCw } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function StockAlertsCard() {
  const token = sessionStorage.getItem('admin_token');
  const [data, setData] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(`${API_URL}/api/admin/stock-alerts`, { headers: { Authorization: `Bearer ${token}` } });
        if (!res.ok) throw new Error();
        setData(await res.json());
      } catch (e) { setErr(true); }
    })();
  }, [token]);

  if (err) return null;
  if (!data) return <div className="bg-white rounded-xl border border-gray-100 p-4"><RefreshCw className="w-4 h-4 text-gray-400 animate-spin" /></div>;

  return (
    <div className="bg-white rounded-xl border border-gray-100 p-4" data-testid="stock-alerts-card">
      <div className="flex items-center justify-between flex-wrap gap-2 mb-1">
        <h3 className="font-bold text-gray-900 text-sm flex items-center gap-2"><Bell className="w-4 h-4 text-amber-500" /> Back-in-Stock Demand</h3>
        <p className="text-xs text-gray-400">{data.pending_total} waiting · {data.notified_total} notified</p>
      </div>
      <p className="text-xs text-gray-500 mb-3">Shoppers who hit &quot;notify me&quot; on sold-out items — your restock shopping list. Alerts auto-send within 30 min of inventory returning.</p>
      {data.demand.length === 0 ? (
        <p className="text-xs text-gray-400 bg-gray-50 rounded-lg p-3" data-testid="stock-alerts-empty">No one is waiting on a restock right now.</p>
      ) : (
        <div className="space-y-1.5" data-testid="stock-alerts-demand">
          {data.demand.map((d, i) => (
            <div key={`${d.product_slug}-${d.size || 'any'}`} className="flex items-center justify-between bg-gray-50 rounded-lg px-3 py-2" data-testid={`stock-demand-row-${i}`}>
              <p className="text-xs text-gray-700 truncate">
                <strong className="text-gray-900">{d.product_name}</strong>
                {d.size && <span className="ml-1.5 px-1.5 py-0.5 bg-amber-50 text-amber-700 rounded text-[10px] font-bold">{d.size}</span>}
              </p>
              <span className="text-xs font-bold text-gray-900 shrink-0">× {d.waiting} waiting</span>
            </div>
          ))}
        </div>
      )}
      {data.recent.length > 0 && (
        <details className="mt-3">
          <summary className="text-[11px] text-gray-400 cursor-pointer">Recent signups ({data.recent.length})</summary>
          <div className="mt-2 space-y-1">
            {data.recent.map((r, i) => (
              <p key={i} className="text-[11px] text-gray-500">
                {r.email} · {r.product_name}{r.size ? ` (${r.size})` : ''} · <span className={r.status === 'notified' ? 'text-emerald-600' : 'text-amber-600'}>{r.status}</span> · {(r.created_at || '').slice(0, 10)}
              </p>
            ))}
          </div>
        </details>
      )}
    </div>
  );
}
